import { Cookies } from 'react-cookie';
import { isServer } from './server.helper';
import { STORAGE_PREFIX } from '../constants/app.constants';

// const localStorage = require('localstorage');

const cookies = new Cookies();

// export function GetLocal(key=null) {
//     if(typeof window !== 'undefined') { 
//         if(key) { return localStorage.getItem(key); }
//         else { return localStorage; }
//     } else {
//         if(key) { return JSON.stringify(localStorage.getItem(key)); }
//         else { return JSON.stringify(localStorage); }
//     }    
// }

// export function SaveLocal(key, value) {
//     if(typeof window !== 'undefined') { 
//         localStorage.setItem(key, value);
//     } else {
//         localStorage.setItem(key, value);
//     }     
// }

// export function RemoveLocal(key) {
//     if(typeof window !== 'undefined') { 
//         localStorage.removeItem(key);
//     } else {
//         localStorage.removeItem(key);
//     } 
// }

const prefix = STORAGE_PREFIX;


export function SaveLocal(key, value) {
    key = prefix + key;
    if (!isServer) {
        localStorage.setItem(key, value);
    } else {
        cookies.set(key, value);
    }
}

export function GetLocal(key = null) {
    key = key ? prefix + key : null;
    if (!isServer) {
        if (key) { return localStorage.getItem(key); }
        else { return localStorage; }
    } else {
        return key ? cookies.get(key) : cookies.getAll();
    }
}

export function RemoveLocal(key) {
    key = prefix + key;
    if (!isServer) {
        localStorage?.removeItem(key);
    } else {
        cookies?.remove(key);
    }
}
